import { forIn, startsWith } from 'lodash'

export function getFiltersFromLocalStorage (tableKey, defaultFilters = []) {
  return getFromLocalStorage(`${tableKey}.filters`, defaultFilters)
}

export function saveFiltersInLocalStorage (tableKey, filters) {
  saveInLocalStorage(`${tableKey}.filters`, filters)
}

export function getColumnsVisibilityFromLocalStorage (tableKey, columns) {
  return getFromLocalStorage(`${tableKey}.columns`, getDefaultColumnsVisibility(columns))
}

export function saveColumnsVisibilityInLocalStorage (tableKey, columnsVisibility) {
  saveInLocalStorage(`${tableKey}.columns`, columnsVisibility)
}

export const mergeColumnsVisibilityWithColumns = (columnsVisibility, columns) => {
  const matched = columnsVisibility
    .map(item => {
      const column = columns.find(col => col.id === item.id)
      return column
        ? ({
          ...column,
          isVisible: item.isVisible,
        })
        : null
    })
    .filter(columnWithVisibility => columnWithVisibility !== null)

  const unmatched = columns
    .filter(
      col => columnsVisibility.find(item => item.id === col.id) === undefined)
    .map(col => ({
      ...col,
      isVisible: true,
    }))

  return [...matched, ...unmatched]
}

export function getSortFromLocalStorage (tableKey, defaultSort) {
  return getFromLocalStorage(`${tableKey}.sort`, defaultSort)
}

export function saveSortInLocalStorage (tableKey, sort) {
  saveInLocalStorage(`${tableKey}.sort`, sort)
}

export function getRowsPerPageFromLocalStorage (tableKey, defaultRowsPerPage = 25) {
  return getFromLocalStorage(`${tableKey}.rowsPerPage`, defaultRowsPerPage)
}

export function saveRowsPerPageInLocalStorage (tableKey, rowsPerPage) {
  saveInLocalStorage(`${tableKey}.rowsPerPage`, rowsPerPage)
}

export function getPageFromLocalStorage (tableKey, defaultPage = 0) {
  return getFromLocalStorage(`${tableKey}.page`, defaultPage)
}

export function savePageInLocalStorage (tableKey, page) {
  saveInLocalStorage(`${tableKey}.page`, page)
}

export function saveTabsDefinitionsInLocalStorage (tableKey, tabsDefinitions) {
  saveInLocalStorage(`${tableKey}.tabsDefinitions`, tabsDefinitions)
}

export function getTabsDefinitionsFromLocalStorage (tableKey, defaultTabsDefinitions = []) {
  return getFromLocalStorage(`${tableKey}.tabsDefinitions`, defaultTabsDefinitions)
}

export function saveSelectedTabInLocalStorage (tableKey, selectedTab) {
  saveInLocalStorage(`${tableKey}.selectedTab`, selectedTab)
}

export function getSelectedTabFromLocalStorage (tableKey, defaultSelectedTab = 0) {
  return getFromLocalStorage(`${tableKey}.selectedTab`, defaultSelectedTab)
}

export function clearLocalStorageByParentKey (parentKey) {
  forIn(localStorage, (value, key) => {
    if (startsWith(key, parentKey)) {
      localStorage.removeItem(key)
    }
  })
}

function getDefaultColumnsVisibility (columns) {
  return columns.map(col => ({
      id: col.id,
      isVisible: !col.isHiddenByDefault,
    }),
  )
}

function saveInLocalStorage (key, value) {
  const val = JSON.stringify(value)
  localStorage.setItem(key, val)
}

function getFromLocalStorage (key, defaultValue) {
  const val = localStorage.getItem(key)
  return val ? JSON.parse(val) : defaultValue
}

